import admin from './user/admin'
import member from './user/member'

export default [
  ...admin,
  ...member
]
